/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "accountsLets-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "audience-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "bitacora-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "bitacorasBudgetsLets-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "budgetLets-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "campaigns-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "categoriesLets-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "configEmail-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "configLetsEmail-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "creatividad-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "etiquetas-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "objEmails-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "OdooConnections-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "pautaobj-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "permisos-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "products-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "roleNames-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "tempCampaignData-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "templates-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "usersLets-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "validaciones-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "views-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "currentAccount-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "log-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "report-LetsAd-cofino-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "tags-LetsAd-cofino-prod",
            "region": "us-east-1"
        }
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "LetsAdCofinoProd",
            "endpoint": "https://ij0g59az37.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_content_delivery_bucket": "etsdcofinoprod-20250922205813-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d3emvw30b7jms6.cloudfront.net"
};


export default awsmobile;
